import { ICategory, IPackageType } from "./PackageFeatures.types";

const stmPackages: ICategory[] = [
    {
        categoryId: 'dashboard',
        category_name: 'Dashboard',
        features: [
            { featureId: 'ftr_overview', feature_name: 'Overview', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_notifications', feature_name: 'Notifications', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_signature_logs', feature_name: 'Signature Logs', essential: false, advanced: true, premium: true }
        ]
    },
    {
        categoryId: 'release_security',
        category_name: 'Release Security',
        features: [
            { featureId: 'ftr_repositories', feature_name: 'Repositories', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_releases', feature_name: 'Releases', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_threat_scanning', feature_name: 'Threat Scanning', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_sbom_cbom', feature_name: 'SBOMs / CBOMs', essential: false, advanced: true, premium: true }
        ]
    },
    {
        categoryId: 'signing',
        category_name: 'Signing',
        features: [
            { featureId: 'ftr_key_management', feature_name: 'Key Management', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_cert_management', feature_name: 'Cert Management', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_test_signing', feature_name: 'Test Signing', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_private_trust', feature_name: 'Private Trust', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_public_trust', feature_name: 'Public Trust', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_gpg_trust', feature_name: 'GPG Trust', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_crypto_profile_controls', feature_name: 'Crypto Profile Controls', essential: false, advanced: false, premium: true }
        ]
    },
    {
        categoryId: 'settings',
        category_name: 'Settings',
        features: [
            { featureId: 'ftr_platform_settings', feature_name: 'Platform Settings', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_teams', feature_name: 'Teams', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_external_pki_trust', feature_name: 'External PKI Trust', essential: false, advanced: false, premium: true }
        ]
    },
    {
        categoryId: 'tools_integrations',
        category_name: 'Tools and Integrations',
        features: [
            { featureId: 'ftr_integrations', feature_name: 'Integrations', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_tools_repository', feature_name: 'Tools Repository', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_apis', feature_name: 'APIs', essential: true, advanced: true, premium: true }
        ]
    },
    {
        categoryId: 'other',
        category_name: 'Other',
        features: [
            { featureId: 'ftr_custom_reports', feature_name: 'Custom reports', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_dedicated_key_storage', feature_name: 'Dedicated Key Storage (Luna HSM or DPOD)', essential: false, advanced: false, premium: true },
            { featureId: 'ftr_sso', feature_name: 'SSO (to platform)', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_rbac', feature_name: 'RBAC', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_over_consumption', feature_name: 'Over consumption', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_audit_logs', feature_name: 'Audit logs', essential: false, advanced: false, premium: true },
        ]
    },
    {
        categoryId: 'alerts',
        category_name: 'Alerts',
        features: [
            { featureId: 'ftr_email', feature_name: 'Email', essential: true, advanced: true, premium: true },
            { featureId: 'ftr_slack_webhook', feature_name: 'Slack/Webhook', essential: false, advanced: true, premium: true },
            { featureId: 'ftr_servicenow_jira_remedy', feature_name: 'ServiceNow/Jira/Remedy', essential: false, advanced: false, premium: true }
        ]
    }
];

const tlmPackages: ICategory[] = [
    {
        categoryId: 'inventory',
        category_name: "Inventory",
        features: [
            {
                featureId: "ftr_em_cloud_scanner",
                feature_name: "Network Discovery - cloud scanner (public IPs)",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_network_discovery",
                feature_name: "Network Discovery - sensor (public/private)",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_system_scan",
                feature_name: "System Scans - agent",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_3rdparty_scans",
                feature_name: "3rd party scans",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_cloud_services_account",
                feature_name: "Cloud services - Account/project level",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_cloud_services_org",
                feature_name: "Cloud services - Org level",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_auto_cert_mgmt",
                feature_name: "Imports via CSV",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_pki8_connector_configuration",
                feature_name: "Imports from CAs",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_service_now_cmdb_integration",
                feature_name: "CMDB",
                essential: false,
                advanced: false,
                premium: true
            }
        ]
    },
    {
        categoryId: 'management',
        category_name: "Management",
        features: [
            {
                featureId: "ftr_em_rest_ui",
                feature_name: "Enroll/Renew via UI",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_rest_api",
                feature_name: "Enroll/Renew via APIs",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_open",
                feature_name: "Self service portal - open",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_authenticated",
                feature_name: "Self service portal - authenticated",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_branding",
                feature_name: "Self service portal - branding",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_acme_scep",
                feature_name: "ACME, SCEP",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_est_aes",
                feature_name: "EST, AES",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_cmp_cmc",
                feature_name: "CMP",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_digicert_trust_assistant",
                feature_name: "Integrations via agent, sensor, DTA",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_intune",
                feature_name: "Intune",
                essential: false,
                advanced: true,
                premium: true
            }
        ]
    },
    {
        categoryId: 'ca',
        category_name: "CAs",
        features: [
            {
                featureId: "ftr_em_cert_central_duplicate_certs",
                feature_name: "CertCentral, Private PKI",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_step_ca",
                feature_name: "Other CAs",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_digicert_on_prem_ca",
                feature_name: "DigiCert On-prem CA",
                essential: false,
                advanced: false,
                premium: true
            }
        ]
    },
    {
        categoryId: 'other',
        category_name: "Other",
        features: [
            {
                featureId: "ftr_em_custom_reporting",
                feature_name: "Custom reports",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_over_consumption",
                feature_name: "Over consumption",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_ldap_search",
                feature_name: "LDAP Search",
                essential: true,
                advanced: true,
                premium: true
            }
        ]
    }
];

const packageTypes: IPackageType[] = [
    {
        package_name: "essential",
        package_id: "pkg_essential",
        active: false,
        canUpgradeTo: ["pkg_advanced", "pkg_premium"],

    },
    {
        package_name: "advanced",
        package_id: "pkg_advanced",
        active: false,
        canUpgradeTo: ["pkg_premium"],
    },
    {
        package_name: "premium",
        package_id: "pkg_premium",
        active: false,
        canUpgradeTo: [],
    }
]

export { tlmPackages, stmPackages, packageTypes };
